import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";

import ImagePreviewer from "./ImagePreviewer";

import * as Types from "../commons/typeDTO";

export type RentImageType = {
    front?: File;
    left?: File;
    back?: File;
    right?: File;
    cluster?: File;
    additionalImages?: File[];
};

function RentImageList({
    rentInputImages,
    inputType,
    resetImage,
    onImageListChanged,
    onDeleteImage,
}: {
    rentInputImages?: Types.RentImageDto[];
    inputType?: boolean;
    resetImage?: any;
    onImageListChanged?: (imageList: RentImageType) => void;
    onDeleteImage?: (rentImageId: number) => void;
}) {
    const [rentImages, setRentImages] = useState<RentImageType>({});

    useEffect(() => {
        if (onImageListChanged !== undefined) {
            onImageListChanged(rentImages);
        }
    }, [rentImages]);

    return (
        <>
            <Row gutter={10}>
                <Col span={12} className="row-gutter">
                    <ImagePreviewer
                        title="전면"
                        value={rentInputImages?.find((item) => item.direction === "front")}
                        enableAdd={rentInputImages?.length === 0}
                        disabled={!inputType}
                        resetImage={resetImage}
                        onImageChanged={(file, imageSrc, isDelete, imageId) => {
                            if (isDelete && imageId) onDeleteImage && onDeleteImage(imageId);
                            file && setRentImages({ ...rentImages, front: file });
                        }}
                    />
                </Col>
                <Col span={12} className="row-gutter">
                    <ImagePreviewer
                        title="운전석 측면"
                        value={rentInputImages?.find((item) => item.direction === "left")}
                        enableAdd={rentInputImages?.length === 0}
                        disabled={!inputType}
                        resetImage={resetImage}
                        onImageChanged={(file, imageSrc, isDelete, imageId) => {
                            if (isDelete && imageId) onDeleteImage && onDeleteImage(imageId);
                            file && setRentImages({ ...rentImages, left: file });
                        }}
                    />
                </Col>

                <Col span={12} className="row-gutter">
                    <ImagePreviewer
                        title="후면"
                        value={rentInputImages?.find((item) => item.direction === "back")}
                        enableAdd={rentInputImages?.length === 0}
                        disabled={!inputType}
                        resetImage={resetImage}
                        onImageChanged={(file, imageSrc, isDelete, imageId) => {
                            if (isDelete && imageId) onDeleteImage && onDeleteImage(imageId);
                            file && setRentImages({ ...rentImages, back: file });
                        }}
                    />
                </Col>
                <Col span={12} className="row-gutter">
                    <ImagePreviewer
                        title="보조석 측면"
                        value={rentInputImages?.find((item) => item.direction === "right")}
                        enableAdd={rentInputImages?.length === 0}
                        disabled={!inputType}
                        resetImage={resetImage}
                        onImageChanged={(file, imageSrc, isDelete, imageId) => {
                            if (isDelete && imageId) onDeleteImage && onDeleteImage(imageId);
                            file && setRentImages({ ...rentImages, right: file });
                        }}
                    />
                </Col>
                <Col span={12} className="row-gutter">
                    <ImagePreviewer
                        title="클러스터"
                        value={rentInputImages?.find((item) => item.direction === "cluster")}
                        enableAdd={rentInputImages?.length === 0}
                        disabled={!inputType}
                        resetImage={resetImage}
                        onImageChanged={(file, imageSrc, isDelete, imageId) => {
                            if (isDelete && imageId) onDeleteImage && onDeleteImage(imageId);
                            file && setRentImages({ ...rentImages, cluster: file });
                        }}
                    />
                </Col>
            </Row>
        </>
    );
}

export default RentImageList;
